import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './components/containers/about/about.component';
import { DatasetComponent } from './components/containers/dataset/dataset.component';
import { DatasetsComponent } from './components/containers/datasets/datasets.component';
import { HomeComponent } from './components/containers/home/home.component';
import { ServiceComponent } from './components/containers/service/service.component';
import { ProjectComponent } from './components/containers/project/project.component';
import { JDSComponent } from './components/containers/jds/jds.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'services', component: HomeComponent },
  { path: 'jewish-data-space', component: JDSComponent },
  { path: 'about', component: AboutComponent },
  { path: 'datasets', component: DatasetsComponent },
  { path: 'datasets/:id', component: DatasetComponent },
  { path: 'services/:id', component: ServiceComponent },
  { path: 'projects/:id', component: ProjectComponent },

  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
